import React, { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import {
  CheckDatainsertintoSnowflake,
  checkReportDataForSDOH,
  CheckReportsData,
  DownloadReports,
  ImportDataintoSnowflakewithTracking,
} from "../../../../api/User/ACG/ExportReportsApi";
import { GetRateReviewReports } from "../../../../api/User/ACG/FinalACGRateReviewApi";
import { Spinner } from "react-bootstrap";
import Fontstyling from "../../../../components/common/comman";
import toastFile from "../../../../Service/ToastFile";

const ExportReports = ({ selectedClientvalue }) => {
  const user = useSelector((state) => state.userDetails.value);
  const Client = useSelector((state) => state.clientData.value);
  const [publishModal, setPublishModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState({
    publish: false,
    download: false,
  });
  const initialValues = {
    largeClaimPrognosisReport: false,
    largeClaimAnalysisReport: false,
    largeClaimDetail: false,
    sdohExtractDetail: false,
    renewalAnalysis: false,
    experienceAnalysis: false,
    asoAnalysis: false,
    allAbove: false,
    censusDetail: false,
    chronicRisk: false,
    biometricsOutput: false,
    gdorReportOutput: false,
    clientID: Client?.clientID,
    client_Name: Client?.clientName,
  };
  const [payload, setPayload] = useState(initialValues);

  const {
    largeClaimPrognosisReport,
    largeClaimAnalysisReport,
    largeClaimDetail,
    sdohExtractDetail,
    renewalAnalysis,
    experienceAnalysis,
    asoAnalysis,
    allAbove,
    censusDetail,
    chronicRisk,
    biometricsOutput,
    gdorReportOutput,
  } = payload;

  useEffect(() => {
    setPayload(initialValues);
  }, [selectedClientvalue]);
  const handleChange = (e) => {
    setPayload((prev) => ({ ...prev, [e.target.name]: e.target.checked }));
  };

  const handleExport = () => {
    //console.log(payload);
    if (Client !== null && Client?.clientID !== 0) {
      if (
        largeClaimPrognosisReport ||
        largeClaimDetail ||
        sdohExtractDetail ||
        renewalAnalysis ||
        experienceAnalysis ||
        asoAnalysis ||
        allAbove ||
        censusDetail ||
        chronicRisk ||
        biometricsOutput ||
        gdorReportOutput
      ) {
        if (sdohExtractDetail) {
          checkReportDataForSDOH(Client?.clientID).then((res) => {
            if (!res.data) {
              toastFile(
                "Census Data is required for the SDOH report. Please import the Census and then try again.",
                "error"
              );
              return;
            } else {
              checkRatereview();
            }
          });
        } else {
          checkRatereview();
        }
      } else {
        toastFile("Please select report(s), and then try again.", "warning");
        return;
      }
    } else {
      toastFile("Select Client");
    }
  };

  const checkRatereview = () => {
    if (
      renewalAnalysis ||
      experienceAnalysis ||
      asoAnalysis ||
      allAbove ||
      censusDetail ||
      chronicRisk
    ) {
      GetRateReviewReports(Client?.clientID, 1, user.UD_id).then((res) => {
        if (res.data.success) {
          setMessage(
            "Some Carriers and plans have Renewal Increase rate of 0%. Do you want to proceed?"
          );
          setShowModal(true);
        } else {
          // setMessage("Have you completed the Underwriting Adjustments?");
          // setShowModal(true);
          setIsLoading({
            publish: false,
            download: true,
          });
          CheckReportsData(payload, user.UD_id).then((res) => {
            if (res.data) {
              downloadfile();
            } else {
              setIsLoading({
                publish: false,
                download: false,
              });
              toastFile("File Not Found.", "error");
            }
          });
        }
      });
    } else {
      setIsLoading({
        publish: false,
        download: true,
      });
      CheckReportsData(payload, user.UD_id).then((res) => {
        if (res.data) {
          downloadfile();
        } else {
          setIsLoading({
            publish: false,
            download: false,
          });
          toastFile("File Not Found.", "error");
        }
      });
    }
  };

  const downloadfile = () => {
    DownloadReports(payload, user.UD_id)
      .then((res) => {
        const blob = new Blob([res.data], {
          type: "application/zip",
        });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `Reports${new Date()
          .toISOString()
          .replace(/[-:.]/g, "")}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      })
      .finally((res) => {
        setIsLoading({
          publish: false,
          download: false,
        });
      });
  };

  const handlePublishIAClick = () => {
    if (Client !== null && Client?.clientID !== 0) {
      setPublishModal(true);
    } else {
      toastFile("Select Client");
    }
  };

  const handleAppendOrReplace = async (value) => {
    setIsLoading({
      publish: true,
      download: false,
    });
    setPublishModal(false);
    try {
      const res = await ImportDataintoSnowflakewithTracking(
        value,
        user.UD_id,
        payload
      );

      let a;
      let response;
      do {
        response = await CheckDatainsertintoSnowflake(res?.data);
        const censusProcess = response.data[0]?.isCensusProcess;
        const chronicProcess = response.data[0]?.isChronicProcess;
        const largeClaimProcess = response.data[0]?.isLargeClaimProcess;
        const isCensusError = response.data[0]?.isCensusError;
        const isChronicError = response.data[0]?.isChronicError;
        const isLargeclaimsError = response.data[0]?.isLargeclaimsError;

        a =
          (payload.censusDetail &&
            !payload.chronicRisk &&
            !payload.largeClaimDetail &&
            (censusProcess || isCensusError)) ||
          (payload.censusDetail &&
            payload.chronicRisk &&
            !payload.largeClaimDetail &&
            (censusProcess || isCensusError) &&
            (chronicProcess || isChronicError)) ||
          (payload.censusDetail &&
            !payload.chronicRisk &&
            payload.largeClaimDetail &&
            (censusProcess || isCensusError) &&
            (largeClaimProcess || isLargeclaimsError)) ||
          (!payload.censusDetail &&
            payload.chronicRisk &&
            !payload.largeClaimDetail &&
            (chronicProcess || isChronicError)) ||
          (!payload.censusDetail &&
            payload.chronicRisk &&
            payload.largeClaimDetail &&
            (chronicProcess || isChronicError) &&
            (largeClaimProcess || isLargeclaimsError)) ||
          (!payload.censusDetail &&
            !payload.chronicRisk &&
            payload.largeClaimDetail &&
            (largeClaimProcess || isLargeclaimsError)) ||
          (payload.censusDetail &&
            payload.chronicRisk &&
            payload.largeClaimDetail &&
            (censusProcess || isCensusError) &&
            (chronicProcess || isChronicError) &&
            (largeClaimProcess || isLargeclaimsError));
        if (!a) {
          await new Promise((resolve) => setTimeout(resolve, 5000)); // Wait for 1 second
        }
      } while (!a);
      if (a) {
        const toastmessage = (
          <div>
            {response.data[0].censusMsg && (
              <>
                <span>{response.data[0].censusMsg}</span>
                <br />
              </>
            )}
            {response.data[0].chronicMsg && (
              <>
                <span>{response.data[0].chronicMsg}</span>
                <br />
              </>
            )}
            {response.data[0].largeClaimMsg && (
              <>
                <span>{response.data[0].largeClaimMsg}</span>
              </>
            )}
          </div>
        );
        if (
          (response.data[0].censusMsg === "" ||
            response.data[0].censusMsg.includes("successfully")) &&
          (response.data[0].chronicMsg === "" ||
            response.data[0].chronicMsg.includes("successfully")) &&
          (response.data[0].largeClaimMsg === "" ||
            response.data[0].largeClaimMsg.includes("successfully"))
        ) {
          toastFile(toastmessage, "success");
        } else {
          toastFile(toastmessage, "warning");
        }
      }
    } finally {
      setIsLoading({
        publish: false,
        download: false,
      });
    }
  };

  return (
    <>
      <Modal show={showModal} aria-labelledby="contained-modal-title-vcenter">
        <Modal.Header closeButton onHide={() => setShowModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={() => {
             
                setIsLoading({
                  publish: false,
                  download: true,
                });
                CheckReportsData(payload, user.UD_id).then((res) => {
                  if (res.data) {
                    downloadfile();
                  } else {
                    setIsLoading({
                      publish: false,
                      download: false,
                    });
                    toastFile("File Not Found.", "error");
                  }
                });
                setShowModal(false);
              
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={() => {
              setShowModal(false);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={publishModal}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <Modal.Header closeButton onHide={() => setPublishModal(false)}>
          <Modal.Title
            id="contained-modal-title-vcenter"
            style={Fontstyling.modalHeading}
          >
            Confirmation
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
        Are you sure you want to publish to IA?
        </Modal.Body>
        <Modal.Footer>
          <Button
            style={Fontstyling.savebutton}
            onClick={(e) => {
              handleAppendOrReplace(2);
            }}
          >
            Yes
          </Button>
          <Button
            style={Fontstyling.cancelbutton}
            onClick={(e) => {
              setPublishModal(false);
              //handleAppendOrReplace(1);
            }}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
      {/* <div style={Fontstyling.heading}>Large Claim Report:</div>
      <ul className="list-group-numbered mt-2" style={Fontstyling.label}>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              checked={largeClaimPrognosisReport}
              name="largeClaimPrognosisReport"
              label="Large Claim(s) Prognosis Report"
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="Large Claim(s) Detail"
              name="largeClaimDetail"
              checked={largeClaimDetail}
            />
          </Form.Group>
        </li>
      </ul> */}
      {/* <div style={Fontstyling.heading}>Final ACG Rate Review:</div>
      <ul className="list-group-numbered mt-2" style={Fontstyling.label}>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="ACG Benchmark Rating Analysis: Current and Renewal Comparison Analysis"
              name="renewalAnalysis"
              checked={renewalAnalysis}
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="ACG Benchmark Rating Analysis: Current and Experience Comparison Analysis"
              name="experienceAnalysis"
              checked={experienceAnalysis}
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="ACG Benchmark Rating Analysis: Current and ASO Comparison Analysis"
              name="asoAnalysis"
              checked={asoAnalysis}
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="All 3 above"
              name="allAbove"
              checked={allAbove}
            />
          </Form.Group>
        </li>
      </ul> */}
      <div style={Fontstyling.heading}>
        Census, Large Claim(s) and Chronic Risk:
      </div>
      <ul className="list-group-numbered mt-2" style={Fontstyling.label}>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="Census Detail"
              name="censusDetail"
              checked={censusDetail}
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="Chronic Risk"
              name="chronicRisk"
              checked={chronicRisk}
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="Large Claim(s) Detail"
              name="largeClaimDetail"
              checked={largeClaimDetail}
            />
          </Form.Group>
        </li>
        {/* <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="SDOH Extract Detail"
              name="sdohExtractDetail"
              checked={sdohExtractDetail}
            />
          </Form.Group>
        </li> */}
      </ul>
      {/* <div style={Fontstyling.heading}>Other:</div>
      <ul className="list-group-numbered mt-2" style={Fontstyling.label}>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="Biometrics Output"
              name="biometricsOutput"
              checked={biometricsOutput}
            />
          </Form.Group>
        </li>
        <li>
          <Form.Group className="">
            <Form.Check
              type="checkbox"
              onChange={handleChange}
              label="GDOR Output"
              name="gdorReportOutput"
              checked={gdorReportOutput}
            />
          </Form.Group>
        </li>
      </ul> */}
      <div className="d-flex slign-items-center gap-3">
        <button
          className={`${isLoading.publish ? "opacity-75" : ""}`}
          style={Fontstyling.addnewbutton}
          onClick={handleExport}
          disabled={isLoading.publish}
        >
          {isLoading.download ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="false"
                style={{ marginRight: "5px" }}
              />
              <span>Download...</span>
            </div>
          ) : (
            "Download Report(s)"
          )}
        </button>
        <button
          className={`${
            isLoading.download ||
            renewalAnalysis ||
            experienceAnalysis ||
            asoAnalysis ||
            allAbove ||
            !(censusDetail || chronicRisk || largeClaimDetail)
              ? "opacity-75"
              : ""
          }`}
          style={Fontstyling.addnewbutton}
          disabled={
            isLoading.download ||
            renewalAnalysis ||
            experienceAnalysis ||
            asoAnalysis ||
            allAbove ||
            !(censusDetail || chronicRisk || largeClaimDetail)
          }
          onClick={handlePublishIAClick}
        >
          {isLoading.publish ? (
            <div className="d-flex justify-content-center align-items-center">
              <Spinner
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="false"
                style={{ marginRight: "5px" }}
              />
              <span>Publish...</span>
            </div>
          ) : (
            "Publish to IA"
          )}
        </button>
      </div>
    </>
  );
};

export default ExportReports;
